import Link from "next/link";
import LazyImage from "@/my_components/Common/LazyImage";
import { useTranslation } from "react-i18next";

// load in utilities
import { image_url } from "@/helper/Utilities";
import { blogPostSlug } from "@/helper/SpecialHelpers";
import { ROUTE } from "@/route/app_routes.js";


const BlogListItems = ({ posts = [] }) => {
  const { t } = useTranslation("blog");

  return (
    <>
      {posts.map((post) => {
        const href = ROUTE.blog_details + blogPostSlug(post);
        const title = t(`posts.${post.id}.title`, post.title);
        return (
          <div className="rbt-card card-list variation-02 rbt-hover mt--30" key={post.id}>
            <div className="rbt-card-img">
              <Link href={href}>
                <LazyImage src={image_url(post.img)} width={580} height={300} alt={title} />
              </Link>
            </div>
            <div className="rbt-card-body">
              <h5 className="rbt-card-title">
                <Link href={href}>{title}</Link>
              </h5>
              <div className="rbt-card-bottom">
                <Link className="transparent-button" href={href}>
                  {t("list.readArticle", "Read Article")}
                  <i>
                    <svg width="17" height="12" xmlns="http://www.w3.org/2000/svg">
                      <g stroke="#27374D" fill="none" fillRule="evenodd">
                        <path d="M10.614 0l5.629 5.629-5.63 5.629" />
                        <path strokeLinecap="square" d="M.663 5.572h14.594" />
                      </g>
                    </svg>
                  </i>
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default BlogListItems;
